import type { FaireProductEntity } from "../../entity_types/product";

export const p_d9h2r5na9p: FaireProductEntity = {
  token: "p_d9h2r5na9p",
  type: "product",
  name: "Oaxaca Wholesale Candle – White Oak, Amber & Vanilla",
  brandToken: "b_5gcihcbntu",
  brandName: "Boheme Fragrances",
  imageUrl:
    "https://cdn.faire.com/fastly/d4bc4e47c902d282411ab08a03f36951d2e1170539b32d0d60ff70785334afb2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6451c9d625312b55fb29ba57531390b870863dd4ab1555b2aba97e6623a95537.jpeg",
    "https://cdn.faire.com/fastly/e2a12e4d97935efbf1d0bebc2e55bdd417fcaf0ecdf7a146c0e5b695f9193cfb.jpeg",
    "https://cdn.faire.com/fastly/91541b63fd2bb72e3b7e36056b1f81f0819fc101ef6c1cf4b56e8df7972cc0f6.jpeg",
    "https://cdn.faire.com/fastly/8045e6684119893d3e6cd3fedf9f75802efac8b75727f80d16eb2b6a0954e222.jpeg",
  ],
  priceDollars: 19,
  description:
    "The Oaxaca Candle is a warm homage to Mexico’s rich artisan culture and ancestral rituals. Anchored in amber and white oak, this fragrance blooms with notes of vanilla, soft spice, and sun-warmed wood—evoking woven textiles, golden dusk, and sacred ceremony.\n\nElegant and grounding, Oaxaca is a beautiful fit for heritage-focused retailers, cultural boutiques, slow-living shops, and modern apothecaries.\n\nFragrance Profile:\n🪵 Top: Soft spice, white oak\n🍯 Middle: Vanilla amber\n🔥 Base: Smoked wood, golden resin\n\nWhy Your Customers Will Love It:\n– Inspired by Oaxaca’s handmade artistry and cultural soul\n– Warm, smoky-vanilla blend with comforting depth\n– Perfect for fall rituals, meditation, or cozy nights in\n– Minimalist design with global storytelling appeal\n\nParaben Free, Phthalate Free, Gluten and Toxin Free, Certified Cruelty-Free Soy Blend Wax and Fragrances.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:44.691Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
